import { StyleSheet } from 'react-native';
import {
  fontFamily,
  fontSizeMedium,
  fontSizeMediumLarge,
  bold,
  medium,
  small,
  xxxlarge,
} from '../../constants/palette';

const styles = StyleSheet.create({
  baseContainer: {
    flex: 1,
    marginTop: medium,
    marginBottom: 50,
  },
  buttonContainer: {
    flex: 1,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  logoContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: medium,
    marginBottom: 5,
  },
  paragraphContainer: {
    marginTop: medium,
    marginBottom: 5,
  },
  sectionContainer: {
    marginTop: medium,
    marginBottom: 20,
    marginLeft: '5%',
    marginRight: '5%',
    width: '80%',
    alignSelf: 'center',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },

  subParagraphContainer: {
    marginTop: 0,
    marginBottom: medium,
    marginLeft: '10%',
  },
  superscriptContainer: {
    flexDirection: 'row',
  },
  superscript: {
    fontSize: small,
    lineHeight: xxxlarge,
  },
  tosBoldText: {
    fontSize: fontSizeMedium,
    fontWeight: bold,
  },
  tosSectionText: {
    fontSize: fontSizeMediumLarge,
    fontWeight: bold,
  },
  tosText: {
    fontSize: fontSizeMedium,
    textAlign: 'left',
  },
  text: {
    fontFamily,
  },
});

export default styles;
